import { Component, OnInit, Input, ChangeDetectorRef, AfterViewChecked, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { Dimension } from '../solucion/Dimension.entity';
import { Etapa } from '../diagnostico/Diagnostico.entity';
import { NavegacionService, PresentacionOk } from '../sidenav.service';
import { CuestionarioHttpServicesService } from '../cuestionario-http-services.service';
import { Router } from '@angular/router';
import { EMPTY_MAP } from '@angular/core/src/view';

@Component({
  selector: 'app-menucuestionario',
  templateUrl: './menucuestionario.component.html',
  styleUrls: ['./menucuestionario.component.css' // , '../../assets/scss/tool-styles.scss'
]
})
export class MenucuestionarioComponent implements OnInit, OnChanges  {

  _esCambioCiclo: Boolean = false;
  @Input('esCambioCiclo')
  set esCambioCiclo(value: Boolean) {
      // console.log('En menu set cambio ciclo.');
      // console.log(value);
      this._esCambioCiclo = value;
  }
  public _dimensiones: Dimension[];
  public _etapas: Etapa[];

  constructor(public navegacionServices: NavegacionService,
    private _cuestionarioServices: CuestionarioHttpServicesService,
    private _router: Router) {

     }
  ngOnChanges(changes: SimpleChanges) {
    // console.log('Onchanges! ');
    const value: SimpleChange = changes.esCambioCiclo;
    this._esCambioCiclo = value.currentValue;
    // this.esCambioCiclo(this.esCambioCiclo) = new Date();
    // this.cdRef.detectChanges();
  }
  ngOnInit() {

    this._cuestionarioServices.getDimension().subscribe(objarray => {
      this._cuestionarioServices.getEtapa().subscribe(objEtapa => {
        this._etapas = objEtapa;
        this._dimensiones = objarray;

        const currEtapa = this.navegacionServices.currentEtapa;
        // console.log('Current etapa', currEtapa);
        this._etapas.forEach( et => {
          if ( et.etapaId <= currEtapa.etapaId ) {
               et.isCompleted = true;
               if (et.etapaId === 4) {
                 this.navegacionServices.irSolucion();
               }
               // console.log('menu', et);
         }
        });
        // this.getClient();
        // console.log('Init menu.');
      });
    });
  }

/*   public getClient() {
        this.currentClient = this.navegacionServices.currentClient;
  } */

}



// WEBPACK FOOTER //
// ./src/app/menucuestionario/menucuestionario.component.ts